"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const snap_ui_input_connector_1 = __importDefault(require("components/form/snap-ui-input-connector"));
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
class FormSectionContact extends React.Component {
    render() {
        const { selectedCountry } = this.props;
        return (React.createElement("div", { id: "contact-information", className: "sui-border sui-p-4 sui-mb-2 sui-border-neutral-border sui-bg-neutral-background sui-rounded" },
            React.createElement("h3", { className: "sui-heading-md sui-font-normal sui-text-gray-40" }, "Contact Information"),
            React.createElement("div", { id: "contact-information-form", className: "" },
                React.createElement(redux_form_1.FormSection, { name: "contactInfos" },
                    React.createElement(redux_form_1.Field, { id: "emailAddresses", name: "emailAddresses", label: "Email", placeholder: "e.g. email@email.com", required: true, className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "text", maxLength: 40, repeater: true, maxRepeats: 5 }),
                    React.createElement(redux_form_1.Field, { id: "phoneNumbers", name: "phoneNumbers", label: "Phone number", placeholder: "123-456-7890", required: true, className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "phone", repeater: true, maxRepeats: 5 }),
                    React.createElement(redux_form_1.Field, { id: "addressStreet", name: "addressStreet", placeholder: "Street name, number, and unit number", label: "Address", className: "sui-mb-2 sui-w-full", component: snap_ui_input_connector_1.default, type: "textarea", maxLength: 200 }),
                    React.createElement("div", { className: "sui-flex sui-mb-2" },
                        React.createElement(redux_form_1.Field, { id: "addressCity", name: "addressCity", label: "City", className: "sui-w-1/2 sui-mr-0.5", component: snap_ui_input_connector_1.default, type: "text", maxLength: 200 }),
                        React.createElement(redux_form_1.Field, { id: "addressState", name: "addressState", label: "State/Province", className: "sui-w-1/2 sui-ml-0.5", component: snap_ui_input_connector_1.default, type: "select", options: (0, snap_ui_1.getStateOptions)(selectedCountry) })),
                    React.createElement("div", { className: "sui-flex sui-mb-2" },
                        React.createElement(redux_form_1.Field, { id: "addressZipcode", name: "addressZipcode", label: "Zip/Postal code", className: "sui-w-1/2 sui-mr-0.5", component: snap_ui_input_connector_1.default, type: "text", maxLength: 200 }),
                        React.createElement(redux_form_1.Field, { id: "addressCountry", name: "addressCountry", label: "Country", className: "sui-w-1/2 sui-ml-0.5", component: snap_ui_input_connector_1.default, type: "select", options: snap_ui_1.COUNTRY_OPTIONS }))))));
    }
}
exports.default = FormSectionContact;
